<template>
  <svg
    v-show="active"
    id="eGnU6OTSsxL1"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="eGnU6OTSsxL2" transform="translate(-1-.5)">
      <path
        d="M17,26c5.2467,0,9.5-4.2533,9.5-9.5s-4.2533-9.5-9.5-9.5-9.5,4.2533-9.5,9.5c0,2.9238.99461,4.5743.99461,4.5743l-.75096,3.958l4.61545-.1337c0,0,1.8921,1.1014,4.6409,1.1014Z"
        fill="#fff"
      />
      <path
        d="M8.49461,21.0743l.98248.1864.07121-.3753-.19719-.3273-.8565.5162Zm3.86449,3.8243l.5032-.8643-.2468-.1436-.2853.0083.0289.9996Zm-4.61545.1337l-.98247-.1864c-.05647.2976.02502.6048.2216.8353s.48703.3595.78984.3507l-.02897-.9996ZM25.5,16.5c0,4.6944-3.8056,8.5-8.5,8.5v2c5.799,0,10.5-4.701,10.5-10.5h-2Zm-17,0C8.5,11.8056,12.3056,8,17,8v-2C11.201,6,6.5,10.701,6.5,16.5h2ZM17,8c4.6944,0,8.5,3.8056,8.5,8.5h2C27.5,10.701,22.799,6,17,6v2ZM8.49461,21.0743c.8565-.5162.8567-.5158.85689-.5155.00006.0001.00024.0004.00036.0006.00023.0004.00045.0007.00065.0011.00041.0006.00076.0012.00104.0017.00058.001.00092.0016.00103.0017.00023.0004-.00046-.0007-.00199-.0034-.00307-.0054-.00955-.017-.01895-.0345-.01881-.0352-.04931-.0945-.08776-.1771-.07694-.1654-.1855-.4239-.29603-.7697C8.72899,18.888,8.5,17.8472,8.5,16.5h-2c0,1.5766.26831,2.8229.54476,3.688.13813.4322.27822.7691.38777,1.0045.05479.1178.102.2103.13758.2768.0178.0333.03269.0601.04419.0803.00575.0101.01065.0186.01464.0254.002.0034.00376.0064.00529.0089.00077.0013.00148.0025.00212.0036.00033.0005.00063.0011.00093.0015.00015.0003.00035.0006.00043.0008.0002.0003.0004.0006.8569-.5155ZM17,25c-1.2422,0-2.2931-.2492-3.0317-.4983-.3684-.1242-.6557-.2473-.8462-.3365-.0951-.0446-.1657-.0806-.2098-.1038-.022-.0116-.0373-.0201-.0458-.0247-.0042-.0024-.0067-.0038-.0074-.0042-.0004-.0002-.0003-.0002.0002.0001.0003.0002.0007.0004.0012.0007.0002.0001.0005.0003.0008.0005.0001.0001.0004.0002.0004.0002.0003.0002.0006.0003-.5026.8646s-.5028.8643-.5025.8645c.0001.0001.0004.0002.0006.0004.0004.0002.0008.0005.0013.0007.001.0006.002.0012.0032.0019.0024.0013.0052.003.0085.0048.0066.0038.0151.0086.0254.0143.0206.0114.0486.0267.0837.0452.0701.037.1688.0871.294.1457.2502.1173.6077.2696,1.0559.4208C14.2238,26.6985,15.4934,27,17,27v-2Zm-4.6698-1.101l-4.61551.1337.05793,1.9992l4.61548-.1338-.0579-1.9991ZM8.72613,25.2187l.75096-3.958-1.96495-.3728-.75096,3.958l1.96495.3728Z"
        fill="#016dbf"
      />
      <path
        d="M16.0683,17.5646h-.0003v.0053.4473c0,.0887.0339.1664.0987.2311.0647.0646.1425.0985.2313.0985h1.372c.1008,0,.1889-.0336.2614-.1007.0715-.066.1253-.1621.1642-.2835l.001.0003.0011-.0101c.0092-.0823.0322-.2392.0695-.4715.0546-.2536.1589-.4892.3135-.707.1663-.2308.3982-.5086.696-.8339.421-.4484.7361-.8424.9438-1.1819.2204-.3539.3295-.7734.3295-1.2563c0-.42-.1196-.8248-.3571-1.2139-.2301-.3924-.6025-.7103-1.1127-.9557-.5039-.2561-1.1468-.3826-1.9262-.3826-.7436,0-1.3955.141-1.9543.4246-.5574.2736-.9848.638-1.2797,1.0939-.294.4546-.451.9433-.47,1.4652v0v.0018c0,.112.0308.2082.0961.2842l-.0002.0001.0028.0027c.067.0669.1553.0985.2593.0985h1.19c.1117,0,.2084-.0294.2865-.0912.0777-.0615.1326-.1517.1673-.2658l.0002.0001.001-.0045c.0917-.4441.2716-.7716.5357-.9884s.6182-.3277,1.0673-.3277c.4005,0,.7391.1134,1.0186.3385v0l.0008.0006c.2748.2124.3945.4978.3589.8635-.0269.2134-.1162.4243-.2705.6328-.1563.2112-.3875.4653-.6946.7626v0l-.0009.0009c-.4212.4299-.7499.8141-.9853,1.1527l-.0002.0002c-.2292.3338-.3671.724-.4145,1.1693Zm.0144,4.3729c.0748.0747.1669.1125.2733.1125h1.358c.1143,0,.2115-.0368.2873-.1125.0749-.0747.1127-.1667.1127-.273v-1.2161c0-.1142-.0369-.2113-.1127-.287s-.173-.1125-.2873-.1125h-1.358c-.1082,0-.2005.0438-.2745.1277-.0741.0745-.1115.166-.1115.2718v1.2161c0,.1063.0378.1983.1127.273Z"
        fill="#016dbf"
        stroke="#016dbf"
        stroke-width="0.1"
      />
    </g>
    <g id="eGnU6OTSsxL6_tr" transform="translate(16,16) rotate(0)">
      <g id="eGnU6OTSsxL6" opacity="0" transform="translate(-17,-16.5)">
        <path
          d="M17,26c5.2467,0,9.5-4.2533,9.5-9.5s-4.2533-9.5-9.5-9.5-9.5,4.2533-9.5,9.5c0,2.9238.99461,4.5743.99461,4.5743l-.75096,3.958l4.61545-.1337c0,0,1.8921,1.1014,4.6409,1.1014Z"
          fill="#000860"
          stroke="#000860"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
        <path
          d="M16.0683,17.5646h-.0003v.0053.4473c0,.0887.0339.1664.0987.2311.0647.0646.1425.0985.2313.0985h1.372c.1008,0,.1889-.0336.2614-.1007.0715-.066.1253-.1621.1642-.2835l.001.0003.0011-.0101c.0092-.0823.0322-.2392.0695-.4715.0546-.2536.1589-.4892.3135-.707.1663-.2308.3982-.5086.696-.8339.421-.4484.7361-.8424.9438-1.1819.2204-.3539.3295-.7734.3295-1.2563c0-.42-.1196-.8248-.3571-1.2139-.2301-.3924-.6025-.7103-1.1127-.9557-.5039-.2561-1.1468-.3826-1.9262-.3826-.7436,0-1.3955.141-1.9543.4246-.5574.2736-.9848.638-1.2797,1.0939-.294.4546-.451.9433-.47,1.4652v0v.0018c0,.112.0308.2082.0961.2842l-.0002.0001.0028.0027c.067.0669.1553.0985.2593.0985h1.19c.1117,0,.2084-.0294.2865-.0912.0777-.0615.1326-.1517.1673-.2658l.0002.0001.001-.0045c.0917-.4441.2716-.7716.5357-.9884s.6182-.3277,1.0673-.3277c.4005,0,.7391.1134,1.0186.3385v0l.0008.0006c.2748.2124.3945.4978.3589.8635-.0269.2134-.1162.4243-.2705.6328-.1563.2112-.3875.4653-.6946.7626v0l-.0009.0009c-.4212.4299-.7499.8141-.9853,1.1527l-.0002.0002c-.2292.3338-.3671.724-.4145,1.1693Zm.0144,4.3729c.0748.0747.1669.1125.2733.1125h1.358c.1143,0,.2115-.0368.2873-.1125.0749-.0747.1127-.1667.1127-.273v-1.2161c0-.1142-.0369-.2113-.1127-.287s-.173-.1125-.2873-.1125h-1.358c-.1082,0-.2005.0438-.2745.1277-.0741.0745-.1115.166-.1115.2718v1.2161c0,.1063.0378.1983.1127.273Z"
          fill="#fff"
          stroke="#fff"
          stroke-width="0.1"
        />
      </g>
    </g>
  </svg>
</template>

<script lang="ts" setup>
type Props = {
  active?: boolean
}

defineProps<Props>()
</script>

<style lang="css">
/* stylelint-disable */

#eGnU6OTSsxL2 {
  animation: eGnU6OTSsxL2_c_o 800ms linear 1 normal forwards;
}
@keyframes eGnU6OTSsxL2_c_o {
  0% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  12.5% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

#eGnU6OTSsxL6_tr {
  animation: eGnU6OTSsxL6_tr__tr 800ms linear 1 normal forwards;
}
@keyframes eGnU6OTSsxL6_tr__tr {
  0% {
    transform: translate(16px, 16px) rotate(0deg);
  }

  25% {
    transform: translate(16px, 16px) rotate(0deg);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }

  50% {
    transform: translate(16px, 16px) rotate(-15deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }

  75% {
    transform: translate(16px, 16px) rotate(15deg);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }

  100% {
    transform: translate(16px, 16px) rotate(0deg);
  }
}

#eGnU6OTSsxL6 {
  animation: eGnU6OTSsxL6_c_o 800ms linear 1 normal forwards;
}
@keyframes eGnU6OTSsxL6_c_o {
  0% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  25% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}
</style>
